import { render, staticRenderFns } from "./ScienceServiceIndex.vue?vue&type=template&id=60ff78fe&scoped=true&"
import script from "./ScienceServiceIndex.vue?vue&type=script&lang=js&"
export * from "./ScienceServiceIndex.vue?vue&type=script&lang=js&"
import style0 from "./ScienceServiceIndex.vue?vue&type=style&index=0&id=60ff78fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ff78fe",
  null
  
)

export default component.exports